import { useEffect } from 'react';
import { REDUX_APP_SET_OVERLAY_CLOSED } from 'redux-state/app/reducer.js';
import { useAppDispatch } from 'redux-state/configure-store.js';
import { REDUX_FAVOURITES_LOAD_ASYNC } from 'redux-state/favourites/reducer.js';
import { REDUX_LOADING_TRUE } from 'redux-state/loading/reducer.js';
import { REDUX_SEARCH_CLOSE_OVERLAY } from 'redux-state/search/reducer.js';

/**
 * When react-router path updates
 * We reset all the state to loading and reset
 */
export const UsePathResetHook = ({ path }: { path: string }) => {
  const appDispatch = useAppDispatch();

  useEffect(() => {
    appDispatch(REDUX_FAVOURITES_LOAD_ASYNC());
  }, [appDispatch]);

  useEffect(() => {
    /** Reset to loading state when path changes, once api call is complete loading state will be set to false  */
    appDispatch(REDUX_LOADING_TRUE());
    appDispatch(REDUX_APP_SET_OVERLAY_CLOSED());
    appDispatch(REDUX_SEARCH_CLOSE_OVERLAY());
  }, [path, appDispatch]);
};
